(function() {
  const THRESHOLD = 20000;

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' lei';
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^\d,.]/g, '');
    if (!cleaned) return null;
    let normalized = cleaned;
    if (cleaned.indexOf(',') > -1) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    }
    const value = parseFloat(normalized);
    if (isNaN(value)) return null;
    return Math.round(value * 100);
  }

  // Calculează totalul citind direct din line-items
  function calculateTotalFromLineItems() {
    // Pe pagina /cart, fiecare rând are:
    // - input quantity: input[name="updates[]"] cu value=cantitate
    // - prețul line total în .cart-item__totals .price--end sau similar
    
    const cartItemRows = document.querySelectorAll('.cart-item');
    if (!cartItemRows.length) return null;

    let total = 0;
    cartItemRows.forEach((row) => {
      // Caută prețul total al liniei (line price)
      const priceEl = row.querySelector('.cart-item__totals .price--end, .cart-item__price-wrapper .price--end, td.cart-item__totals span.price');
      if (priceEl) {
        const cents = parseMoneyToCents(priceEl.textContent);
        if (cents !== null) {
          total += cents;
        }
      }
    });

    return total > 0 ? total : null;
  }

  function getCartTotalFromDOM() {
    // Întâi încearcă să-l ia din footer (cel mai sigur)
    let el = document.querySelector('#main-cart-footer .totals__total-value');
    if (el) {
      const cents = parseMoneyToCents(el.textContent);
      if (cents !== null) return cents;
    }
    
    // Fallback: calculează din line items
    const computed = calculateTotalFromLineItems();
    if (computed !== null) return computed;

    // Last resort: orice .totals__total-value vizibil
    const allTotals = document.querySelectorAll('.totals__total-value');
    for (const elem of allTotals) {
      if (elem.offsetParent !== null) {
        const cents = parseMoneyToCents(elem.textContent);
        if (cents !== null) return cents;
      }
    }

    return null;
  }

  function updateBar(cartTotal) {
    if (cartTotal === null || cartTotal === undefined) return;

    const bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    const remaining = THRESHOLD - cartTotal;
    const percent = Math.min((cartTotal / THRESHOLD) * 100, 100);

    bars.forEach((bar) => {
      const messageEl = bar.querySelector('[data-fs-message]');
      const fillEl = bar.querySelector('[data-fs-fill]');

      if (fillEl) fillEl.style.width = percent + '%';

      if (messageEl) {
        if (remaining > 0) {
          messageEl.innerHTML =
            '<span class="free-shipping-bar__icon">🚚</span> ' +
            'Ești la <strong>' + formatMoney(remaining) +
            '</strong>  de <strong>livrare gratuită in Iași!</strong>';
          bar.classList.remove('is-complete');
        } else {
          messageEl.innerHTML =
            '<span class="free-shipping-bar__icon">🎉</span> ' +
            'Felicitări! Ai <strong>transport gratuit</strong> la această comandă.';
          bar.classList.add('is-complete');
        }
      }
    });
  }

  function syncFromDOM() {
    const total = getCartTotalFromDOM();
    if (total !== null) {
      updateBar(total);
    }
  }

  function init() {
    syncFromDOM();

    window.addEventListener('load', () => {
      syncFromDOM();
      setTimeout(syncFromDOM, 200);
      setTimeout(syncFromDOM, 800);
    });

// POLLING la 500ms — citește și actualizează MEREU
    setInterval(() => {
      syncFromDOM();
    }, 500);

    // Click fail-safe
    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest('.quantity__button, cart-remove-button button, .cart-remove-button')) {
        setTimeout(syncFromDOM, 300);
        setTimeout(syncFromDOM, 800);
        setTimeout(syncFromDOM, 1500);
      }
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, syncFromDOM);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();